export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'È davvero adatto a tutte le classi o è troppo generico?',
    answer:
      'C’è un volume dedicato a ogni anno scolastico, dalla 1ª Primaria alla 3ª Media (6-14 anni), e ogni unità propone un’attività graduata su 3 livelli. Così puoi usare lo stesso percorso con tutta la classe, adattando la richiesta al singolo alunno.',
  },
  {
    question: 'Devo comprare mappe o materiali particolari?',
    answer:
      'No. La quasi totalità del materiale è già pronta da stampare, mappe comprese. È incluso anche il bonus "Geografia Senza Materiali: 40 Attività", pensato per le lezioni in cui non hai nulla a disposizione.',
  },
  {
    question: 'Quanto tempo mi fa risparmiare rispetto a preparare da zero?',
    answer:
      'Il percorso è già strutturato: 64 unità con introduzione, attività, scheda operativa e verifica. Non devi cercare, selezionare e mettere in sequenza nulla — apri il volume dell’anno e la lezione è pronta.',
  },
  {
    question: 'Posso usarlo anche se non sono uno specialista di geografia?',
    answer:
      'Sì, è proprio il caso più frequente. Ogni attività ha una guida passo passo per il docente, e il bonus "Il Kit di Sopravvivenza per il Docente di Geografia" raccoglie definizioni, spiegazioni e risposte pronte alle domande più comuni della classe.',
  },
  {
    question: 'Se non mi piace, posso chiedere il rimborso?',
    answer:
      'Certo. Hai 30 giorni per richiedere il rimborso completo dell’importo, senza domande e senza complicazioni.',
  },
]
